<template>
  <div class="notification" v-click-outside="hideNotification">
    <div class="notification-toggle" @click="showNotification">
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.72729 18.9091C4.72729 19.5618 5.25639 20.0909 5.90911 20.0909H10.6364C10.6364 21.3964 11.6946 22.4546 13 22.4546C14.3055 22.4546 15.3637 21.3964 15.3637 20.0909H20.0909C20.7437 20.0909 21.2728 19.5618 21.2728 18.9091C21.2728 18.2564 20.7437 17.7273 20.0909 17.7273V11.8182C20.0909 8.30465 17.5355 5.38793 14.1818 4.82526V4.72729C14.1818 4.07457 13.6527 3.54547 13 3.54547C12.3473 3.54547 11.8182 4.07457 11.8182 4.72729V4.82526C8.46456 5.38793 5.90911 8.30465 5.90911 11.8182V17.7273C5.25639 17.7273 4.72729 18.2564 4.72729 18.9091ZM13 7.02368L13.7908 7.1564C16.0248 7.53116 17.7273 9.4782 17.7273 11.8182V17.7273H8.27275V11.8182C8.27275 9.4782 9.97528 7.53116 12.2093 7.1564L13 7.02368Z"
          fill="var(--menu-text-color)"
        />
        <circle
          v-if="hasNotification"
          cx="18.9091"
          cy="7.09093"
          r="3.54545"
          fill="#D53E29"
        />
      </svg>
    </div>

    <notifications-list :notifications="notifications" />
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import notificationsList from '@/components/controls/notificationsList'
import { notificationStore } from '@/utils/notificationStore'

export default {
    directives: {
        ClickOutside,
    },
    components: {
        notificationsList,
    },
    computed: {
        ...mapGetters({
            masterWasLateGetters: 'masterWasLateGetters',
            showNotificationGetters: 'showNotificationGetters',
            isShowNotification: 'isShowNotification',
        }),
        admin() {
            return this.$store.state.admin.data
        },

        notifications() {
            if (this.$store.state.notifications.notifications === null) {
                return []
            }
            if (this.$store.state.notifications.notifications[0] === null) {
                return []
            }

            if (
                this.$store.state.notifications.notifications
        && this.$store.state.notifications.notifications.length
            ) {
                const noty = this.$store.state.notifications.notifications[0]

                let title = ''
                let message = ''

                const { type } = noty
                const notification_id = noty.items[0].id
                const item = noty.items[0]

                // const { landing_request_id } = item
                const lastItem = noty.items[noty.items.length - 1]
                const data = noty.items
                let id = null

                switch (type) {
                // case "new_landing_request":
                //   const view = this.$t("notifications.newLandingRequestDesc");
                //   title = this.$t("notifications.newLandingRequest");
                //   notificationMananger.addToPull({
                //     route: {
                //       name: "Requests",
                //       notification_id,
                //       landing_request_id
                //     },
                //     data: [item],
                //     id: landing_request_id
                //   });

                //   message = `<span style="cursor: pointer" onclick="notificationMananger.onNewLandingRequest('${landing_request_id}')">${view}</span>`;
                //   break;

                case 'message':
                    title = this.$t('notifications.newMessage')

                    const messageView = this.$t('notifications.messageDescription')
                    const clientId = noty.items[0].client_id
                    const masterId = noty.items[0].master_id

                    window.notificationMananger.addToPull({
                        route: {
                            id: masterId === null ? clientId : masterId,
                            type: noty.items[0].dialog_type,
                            notification_id,
                            name: 'chat',
                        },
                        item,
                        data,
                        id: item.id,
                    })

                    message = `<span 
                            style="cursor: pointer" 
                            onclick="notificationMananger.onMessage('${item.id}')"
                            >
                                ${messageView}
                            </span>`
                    break

                case 'new_request':
                    const requestId = lastItem.request_id
                    window.notificationMananger.addToPull({
                        route: {
                            name: 'orders',
                            notification_id: lastItem.id,
                            requestId,
                        },
                        item: lastItem,
                        data: [lastItem],
                        id: lastItem.id,
                    })
                    id = lastItem.id

                    message = `<span 
                style="cursor: pointer" 
                onclick="notificationMananger.onNewRequest('${id}')">${this.$t(
    'notifications.viewNewRequest',
)}</span>`
                    title = this.$t('notifications.newRequest')
                    break

                case 'new_client':
                    title = this.$t('notifications.newClient')
                    message = this.$t('notifications.clientDescription')
                    break
                case 'call':
                    title = this.$t('notifications.missedCall')
                    message = `${this.$t('notifications.missedCallText')} ${
                        item.name
                    }. ${this.$t('notifications.callBack')}`
                    break
                case 'missed_call':
                    title = this.$t('notifications.missedCall')
                    message = `${this.$t('notifications.missedCall')} ${this.$t(
                        'notifications.callBack',
                    )}`
                    break
                case 'cancel_request':
                    title = `${item.name} ${this.$t('notifications.cancelRequest')}`
                    break
                default:
                    break
                }

                if (this.showNotificationGetters) {
                    this.setShowNotification(false)
                    const notificationInstance = this.$notify({
                        title,
                        dangerouslyUseHTMLString: true,
                        message,
                        duration:
              type === 'new_landing_request' || type === 'new_request'
                  ? 120000
                  : 5000,
                    })

                    // signaling
                    if (type === 'new_request') {
                        notificationStore.add(lastItem.request_id, notificationInstance)
                    }
                    // else if (type === "new_landing_request") {
                    //   notificationStore.add(landing_request_id, notificationInstance);
                    // }
                    // signaling
                }
            }
            return this.$store.state.notifications.notifications
        },
        hasNotification() {
            return this.notifications?.length > 0
        },
    },
    data() {
        return {
            backgroundImage: '/images/default-user.svg',
            typeList: ['registration', 'request', 'message', 'call', 'abort-request'],
            notificationMananger: null,
            isShow: false,
            isHide: false,
        }
    },
    watch: {
        admin(v) {
            this.backgroundImage = v.small_image === null ? this.backgroundImage : v.small_image
        },
    },
    methods: {
        ...mapMutations({
            setMasterWasLate: 'setMasterWasLate',
            setShowNotification: 'setShowNotification',
            hideNotification: 'hideNotification',
            showNotification: 'showNotification',
        }),
        ...mapActions({
            readNotification: 'readNotification',
        }),
        hideNotification2() {
            if (this.isShow) {
                this.isHide = true

                setTimeout(() => {
                    this.isShow = !this.isShow
                    this.isHide = false
                }, 200)
            }
        },
        toggleNotification() {
            if (this.isShow) {
                this.isHide = true

                setTimeout(() => {
                    this.isShow = !this.isShow
                    this.isHide = false
                }, 200)
            } else {
                this.isShow = !this.isShow
            }
        },
        setImage() {
            this.backgroundImage = this.admin.small_image === null
                ? this.backgroundImage
                : this.admin.small_image
        },
        setNotificationManager() {
            window.notificationMananger.setContext(this)
        },
    },
    async beforeMount() {
        this.setNotificationManager()
        await this.$store.dispatch('getAdminData')
        this.setImage()
    },
}
</script>
<style lang="scss">
@import "src/assets/sass/main";

@keyframes show {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes hide {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.header {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  display: flex;
  justify-content: space-between;
  background-size: contain;
  padding: 3px;
  background-repeat: no-repeat;
  // padding-right: 15px;
  box-sizing: border-box;
  @include respond(tablet) {
    padding-right: 2%;
  }

  &-logo {
    width: 70%;
    display: flex;
    justify-content: center;
    align-items: center;

    @include respond(tablet) {
      justify-content: flex-start;
      padding-left: 9%;
    }
  }

  &__wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
    width: 100%;
    max-width: 300px;
  }

  &__user {
    display: flex;
    align-items: center;
    height: 100%;
    padding-left: 5px;
    width: 100%;

    &-img {
      width: 45px;
      height: 45px;
      background-size: cover;
      background-position: center;
      border-radius: 50%;
      border: 2px solid $secondColor;
      margin-right: 10px;
    }

    &-text {
      font-size: 16px;
      color: #61422d;
      margin-right: 28px;
      width: 100%;
      max-width: 150px;

      @include respond(tablet) {
        display: none;
      }
    }
  }

  &__notification {
    height: 64px;
    width: 64px;
    background-image: url("/images/icon/notification.svg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 36px;
    transition: 1s;

    &.active {
      background-color: rgba($primaryColor, 0.15);
    }

    cursor: pointer;

    &--active {
      background-image: url("/images/icon/notification-new.svg");
    }
  }
}

.toggle-notification {
  // position: absolute;
}

.notification {
  position: absolute;
  right: 25px;
  top: 17px;
  z-index: 4;

  &-toggle {
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
  }

  &-box {
    margin-top: 13px;
    width: 460px;
    border: 1px solid var(--border-color);
    background-color: var(--bg-color);
    border-radius: 4px;
    position: relative;
    z-index: 2;
    right: -10px;
    display: none;

    &_show {
      display: block;
      animation: show 0.2s ease-in;
    }

    &_hide {
      animation: hide 0.2s ease-in;
    }

    &::before {
      position: absolute;
      content: "";
      z-index: 3;
      width: 12px;
      height: 12px;
      border-left: 1px solid var(--border-color);
      border-top: 1px solid var(--border-color);
      transform: rotate(45deg);
      right: 16px;
      top: -7px;
      border-radius: 4px 0 0 0;
      background-color: var(--bg-color);
    }

    &__list {
      width: 100%;
      height: 536px;
      overflow-y: scroll;
    }
  }

  &-item {
    position: relative;
    // background-color: inherit;
    transition: background-color 0.2s ease-in;
    &:hover {
      background-color: var(--bg-color2);
      cursor: pointer;
    }

    &:not(&:first-child) {
      border-top: 1px solid var(--border-color);
    }

    &::before {
      position: absolute;
      content: "";
      top: 0;
      bottom: 0;
      left: 41px;
      z-index: 3;
      width: 1px;
      height: 100%;
      background-color: var(--bg-color3);
    }

    &__box {
      padding: 24px;
      display: flex;
      align-items: center;
    }

    &__image {
      width: 32px;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: var(--bg-color3);
      border-radius: 50%;
      margin-right: 11px;
      position: relative;
      z-index: 4;

      img {
        width: 20px;
        height: 20px;
      }
    }

    &__text {
      color: #828d99;
      font-size: 13px;
      line-height: 20px;

      &-name {
        color: #9bcd82;
        font-family: "crosten-bold";
        margin-right: 4px;
      }
    }

    &__title {
      font-size: 13px;
      line-height: 20px;
      font-family: "crosten-bold";
      color: var(--menu-text-color);
    }

    &__time {
      font-size: 12px;
      line-height: 20px;
      color: #828d99;
      margin-left: auto;
      margin-bottom: auto;
    }
  }
}

// .notification {
//   position: fixed;
//   top: 64px;
//   right: 0;
//   width: 491px;
//   max-height: 475px;
//   height: 100%;
//   background-color: #ffffff;
//   box-shadow: 0 16px 24px 0 rgba(0, 0, 0, 0.16);
//   transform: translateX(102%);
//   transition: 1s;

//   &.active {
//     transform: translateX(0);
//   }

//   &__wrapper {
//     height: 100%;
//     overflow: hidden;
//   }

//   &__list {
//   }

//   &__item {
//     display: flex;
//     align-items: center;
//     justify-content: flex-start;
//     height: 95px;
//     width: 100%;
//     padding-left: 16px;
//     padding-right: 21px;
//     box-sizing: border-box;
//     border-bottom: 1px solid rgba($primaryColor, 0.15);
//     transition: 0.5s;
//     cursor: pointer;

//     &--new {
//       background-color: rgba($primaryColor, 0.15);
//       border-bottom: none;

//       & .notification__item-status {
//         border-color: #71bd4a;
//       }
//     }

//     &--group {
//       & .notification__item-img {
//         border: none;
//       }
//     }

//     &--registration {
//     }

//     &:hover {
//       background-color: rgba($primaryColor, 0.15);
//     }

//     &-status {
//       width: 3px;
//       height: 3px;
//       border: 3px solid #71bd4a;
//       border-color: rgba(255, 255, 255, 0);
//       border-radius: 50%;
//       margin-right: 16px;
//     }

//     &-img {
//       width: 36px;
//       height: 36px;
//       border: 1px solid $secondColor;
//       border-radius: 50%;
//       background-size: cover;
//       background-position: center;
//       margin-right: 16px;
//       background-color: $primaryColor;
//       color: #ffffff;
//       display: flex;
//       justify-content: center;
//       align-items: center;
//       font-size: 16px;
//     }

//     &-content {
//     }

//     &-type {
//       font-size: 16px;
//       color: $primaryColor;
//       font-family: $fontBold;
//       font-family: $fontBold;
//       margin-bottom: 4px;
//     }

//     &-text {
//       font-size: 12px;
//       color: #4d4d4d;

//       & span {
//         font-family: $fontBold;
//       }
//     }
//   }
// }

.router-link-exact-active {
  background-color: rgba(#71bd4a, 0.15);
}
</style>
